import { selectorStyles } from '../styles';
import { placeholderText } from '../consts';

const selectorProps = {
  styles: {
    ...selectorStyles,
    container: provided => ({ ...provided, fontSize: 17, marginBottom: 32 }),
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? '#19202d' : '#d7dfe7',
      '&:hover': {
        borderColor: '#19202d',
      },
      borderRadius: 3,
      borderBottomLeftRadius: state.menuIsOpen ? 0 : 3,
      borderBottomRightRadius: state.menuIsOpen ? 0 : 3,
      outline: 'none',
      boxShadow: 'none',
      height: 40,
    }),
    menu: provided => ({
      ...provided,
      marginTop: 0,
      borderRadius: 3,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderColor: '#19202d',
      borderStyle: 'solid',
      borderWidth: 1,
      borderTopWidth: 0,
    }),
    menuList: provided => ({
      ...provided,
      display: 'flex',
      flexDirection: 'column',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#f3f5fa' : '#fff',
      color: '#19202d',
      margin: 0,
      padding: '10px 14px',
      width: 'auto',
      border: 'none',
      borderBottom: '1px solid #d7dfe7',
      opacity: state.isDisabled ? 0.4 : 1,
      '&:last-child': { borderBottom: 'none' },
    }),
  },
  classNamePrefix: 'sel',
  noOptionsMessage: () => 'no results',
  placeholder: placeholderText,
  components: {
    IndicatorsContainer: () => null,
  },
};

export default selectorProps;
